import { render, staticRenderFns } from "./ReviewsCenterRail.vue?vue&type=template&id=0ee308dd&scoped=true&"
import script from "./ReviewsCenterRail.vue?vue&type=script&lang=js&"
export * from "./ReviewsCenterRail.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCenterRail.vue?vue&type=style&index=0&id=0ee308dd&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee308dd",
  null
  
)

export default component.exports